import { render } from "./ToDeliver.vue?vue&type=template&id=3c87665c"
import script from "./ToDeliver.vue?vue&type=script&lang=js"
export * from "./ToDeliver.vue?vue&type=script&lang=js"

import "./ToDeliver.vue?vue&type=style&index=0&id=3c87665c&lang=scss"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__